import { render, staticRenderFns } from "./ModalAjukanBarangHilang.vue?vue&type=template&id=6d0effc5&"
import script from "./ModalAjukanBarangHilang.vue?vue&type=script&lang=js&"
export * from "./ModalAjukanBarangHilang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports